export const ProfileData = {
    Name: 'Harry Potter',
    UserName: 'hpotter',
    Gender: 'Male',
    Year: 'Sophomore',
    Age: '21',
    Major: 'Computer Science',
    Cleanliness: 'Very Clean',
    Guests: 'No guests',
    TimeSpent: 'Mostly in room',
    Noise: 'Quiet',
    Pets: 'No pets',
    Lifestyle: 'Early bird',
}